import React from 'react'
import classes from './checkbox.module.css'
import classNames from 'classnames'

const Checkbox = ({ checked, onToggle, id }) => (
    <button
        className={classNames(
            classes.checkbox,
            checked && classes.checkboxActive
        )}
        onClick={() => onToggle(id)}
    />
)

export default Checkbox
